import React from 'react'
import appConfig from 'configs/app.config'
import { REDIRECT_URL_KEY } from 'constants/app.constant'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import useAuth from 'utils/hooks/useAuth'

const { unAuthenticatedEntryPath,onBoardingEntryPath } = appConfig

const ProtectedRoute = () => {
    const { authenticated } = useAuth()
    const onboaringsurvey = localStorage.getItem("onboaringsurvey")
    const location = useLocation()
    
    let forWix = location.pathname+""+location.search;
    const substringInstance = "?instance=";
    if (location.search && location.search.includes(substringInstance)) {
        forWix = "/dashboard/stores/wix-auth-callback"+location.search;
    }
    
    
    
    
    if (!authenticated) {
        return (
            <Navigate
                to={`${unAuthenticatedEntryPath}?${REDIRECT_URL_KEY}=${forWix}`}
                replace
            />
        )
    }
    if (onboaringsurvey) {
        return (
            <Navigate
                to={`${onBoardingEntryPath}`}
                replace
            />
        )
    }
    return <Outlet />
}

export default ProtectedRoute
